(() => {
  'use strict';
  if (globalThis.AsteriaGateEntryShopBound) return;
  globalThis.AsteriaGateEntryShopBound = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('.ae-gate-shop-jump');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    target.focus({ preventScroll: true });
  });
})();
